import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { ToastrService } from 'ngx-toastr';

import { env } from '../../../../environments/environment';
import { Currency, ExchangeRatesDto } from '../../../api';
import { DigitsInfo } from '../../../bo/digitsInfo';
import { PayPalConfig } from '../../../bo/payPalConfig';

import { GlobalService } from '../../../global.service';
import { NarwhalService } from '../../../narwhal.service';
import { PaymentService } from '../../../payment.service';
import { Web3Service } from '../../../web3.service';
import { defs } from '../../../defs';
import { NGXLogger } from 'ngx-logger';
import { Money } from '../../../bo/money';
import { NarwhalDto } from '../../../api/narwhalDto';

declare let paypal: any;

@Component({
	selector: 'narwhalia-buy-popup',
	templateUrl: './buy-popup.component.html',
	styleUrls: ['./buy-popup.component.scss']
})
export class BuyPopupComponent extends OnDestroyMixin implements OnInit, OnChanges, AfterViewInit {
	@Input() narwhal: NarwhalDto;
	@Output() closePopup: EventEmitter<boolean>;
	price: Money;
	digitsInfo: DigitsInfo;
	glitterBalance: number;
	rates: ExchangeRatesDto;
	paypalConfig: PayPalConfig;
	etherBalance: number;
	Currency = Currency

	private paypalMethods = {
		payment: () => this.narwhalService.buyNarwhal(this.narwhal.id, Currency.USD)
				.then(res => res.payPalPaymentId),
		onAuthorize: (data, actions) =>
			this.paymentService
				.finalizePayPalPayment(data.paymentID, data.payerID)
				.then(() => {
					this.close(true);
				})
				.catch(() => {
					this.translateService
						.get('error.payment.pay_pal_rest_exception')
						.subscribe(translatedText => this.toastrService.error(translatedText));
					this.close();
				}),
		onCancel: data =>
			this.paymentService
				.deletePayPalPayment(data.paymentID)
				.catch(() =>
					this.translateService
						.get('error.payment.pay_pal_rest_exception')
						.subscribe(translatedText => this.toastrService.error(translatedText))
				)
				.then(() => this.close())
	};

	@HostListener('document:click', ['$event'])
	clickedOutside(event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.close();
		}
	}

	constructor(
		private narwhalService: NarwhalService,
		private elementRef: ElementRef,
		private web3Service: Web3Service,
		private paymentService: PaymentService,
		private globalService: GlobalService,
		private translateService: TranslateService,
		private toastrService: ToastrService,
		private log: NGXLogger
	) {
		super();
		this.digitsInfo = defs.digitsInfo;
		this.closePopup = new EventEmitter<boolean>();
		this.paypalConfig = {
			env: env.payPal.env,
			commit: env.payPal.commit,
			style: env.payPal.style,
			payment: this.paypalMethods.payment,
			onAuthorize: this.paypalMethods.onAuthorize,
			onCancel: this.paypalMethods.onCancel
		};
	}

	close = (isSuccessful = false) => {
		this.closePopup.emit(isSuccessful);
	};

	ngOnInit() {
		this.globalService.exchangeRates.pipe(untilComponentDestroyed(this))
			.subscribe((rates: ExchangeRatesDto) => {
				this.rates = rates;
				this.exchangePrice();
		});
		this.globalService.getBalances().pipe(untilComponentDestroyed(this))
			.subscribe(balances => {
				this.glitterBalance = balances.balance;
			});
		this.web3Service.getBalance()
			.then(etherBalance => {
				this.etherBalance = etherBalance;
				this.log.debug('BuyPopupComponent.etherBalance', this.etherBalance)
			})
			//.catch(this.handleError);
	}

	ngOnChanges() {
		this.exchangePrice();
	}

	exchangePrice() {
		this.log.debug('BuyPopupComponent.exchangePrice', this.rates)
		if (this.rates) {
			const usd = this.narwhal.price.act * this.rates.gli_usd;
			const eth = usd / this.rates.eth_usd;
			this.price = {
				usd,
				eth
			};
		}
	}

	buyNarwhal(currency: Currency) {
		this.web3Service
			.init()
			.then(() => this.narwhalService.buyNarwhal(this.narwhal.id, currency))
			.then(this.web3Service.send)
			.then(() => this.close(true))
			.catch(err => {
				//console.error(err);
				this.close();
			});
	}
/*
	transfer = (response: BuyResponseDto) => {
		return (response)
			.catch(this.handleError);
	};
*/
	ngAfterViewInit() {
		paypal.Button.render(this.paypalConfig, `paypal-button-${this.narwhal.id}`);
	}
}